import { StyledProps, React, withStyles, Fragment} from '@api';
import {Slider, Divider, TextField, Typography, CircularProgress, Backdrop, Portal } from '@material-ui/core'
import Popover from '@material-ui/core/Popover'
import {CatalogStore} from '@stores/catalog'

import { SecondaryButton } from 'centric-ui-components'
import { observer} from 'mobx-react';
import {checkIntegersOnly} from '@utils';


const styles = () => ({
  massPopoverModal: {
    width: 287,
    height: 200,
    backgroundColor: '#ffffff'
  },
  massCreateHeader: {
    width: 300,
    height: 42,
    backgroundColor: '#ffffff'
  },
  massHeaderText: {
    width: 92,
    height: 24,
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: 0.1,
    color: 'rgba(27, 27, 27, 0.87)',
    marginTop: 20,
    marginLeft: 24
  },
  massCreateFooter: {
    height: 52,
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    justifyContent: 'flex-end'
  },
  massCreateInput: {
    display: 'flex',
    height: 99,
    alignItems: 'center'
  },
  inputDiv: {
    marginLeft: 35,
    marginRight: 20
  },
  downArrow: {
    fill: '#4184f3',
    borderColor: '#4184f3',
    border: '1px solid #4184f3',
    width: 32,
    height: 32,
    borderRadius: 4
  },
  arrowButton: {
    width: 56,
    height: 56
  },
  textField: {
    marginTop: '-22px',
    width: 45
  },
  colorSecondary: {
    margin: '0 32px',
    width: '25px !important',
    height: '25px !important'
  },
  loadingContainer: {
    zIndex: 9999
  },
  progressText: {
    zIndex: 99999,
    opacity: 1,
    top: '44%',
    position: 'fixed',
    color: 'white',
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: 0.1,
    width: '100%',
    textAlign: 'center'
  },
  progressIcon: {
    color: '#4184f3',
    position: 'fixed',
    width: 56,
    height: 56,
    zIndex: 99999,
    opacity: 1,
    top: '50%',
    left: 'calc(50% - 28px)'
  },
  root: {
    width: 160,
    marginLeft: 15
  },
  slider: {
    padding: '22px 0px'
  },
  sliderColor: {
    backgroundColor: 'var(--secondary)'
  }
})

interface MyProps extends StyledProps {
  libraryType?: String
  catalog: CatalogStore
}

const MIN_PRODUCTS_TO_SHOW_MODAL_LOADING = 0

@(withStyles as any)(styles)
@observer
export class ProductCountPopOver extends React.Component <MyProps> {
  render() {
      const {classes, libraryType, catalog} = this.props,
        {massCreate: {anchorEl, onCloseMassCreation, loading, productCount, bulkCreateProduct, onChangeProductCount, uploadingMessage, handleSlider, bulkCreateSpecification}} = catalog
      return loading && productCount > MIN_PRODUCTS_TO_SHOW_MODAL_LOADING ? <Portal>
        <Fragment>
       <Backdrop open={loading} classes={{root: classes.loadingContainer}} />
        <Typography className={classes.progressText}> {
          uploadingMessage ? uploadingMessage : libraryType ? `Creating ${libraryType} ...` : 'Creating Products ...'
        }</Typography>
        <CircularProgress size={56} className={classes.progressIcon} />
      </Fragment>
    </Portal> :
      <Popover
        id="simple-popper"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onCloseMassCreation}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.massPopoverModal}>
          <div className={classes.massCreateHeader}>
            <Typography className={classes.massHeaderText}> Mass Create </Typography>
          </div>
          <Divider />
          <div className={classes.massCreateInput}>
            <div className={classes.root}>
              <Slider
                value={productCount}
                min={0}
                max={10}
                step={1}
                onChange={handleSlider}
                classes={{thumb: classes.sliderColor, track: classes.sliderColor}}
              />
            </div>
            <div className={classes.inputDiv}>
              <TextField
                id="standard-name"
                className={classes.textField}
                value={productCount}
                onChange={onChangeProductCount}
                margin="normal"
                onKeyPress={checkIntegersOnly}
                inputProps={{ maxLength: 3 }}
                onPaste={checkIntegersOnly}
              />
            </div>
          </div>
          <Divider />
          <div className={classes.massCreateFooter}>
            <SecondaryButton
              onClick={onCloseMassCreation}
            >
              Cancel
              </SecondaryButton>
            <SecondaryButton disabled={!(productCount > 0 && productCount < 1000)}
              onClick={libraryType ? bulkCreateSpecification : bulkCreateProduct}>
              Create
              </SecondaryButton>
          </div>
        </div>
      </Popover>
  }
}




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/ProductCountPopOver.tsx